/* ALTRA V5 scroll reveal + word-stagger headings + review auto-drift.
   Safe in theme editor and without JS. */
(function () {
  'use strict';
  if (window.__alv5Init) return;
  window.__alv5Init = true;
  if (window.Shopify && window.Shopify.designMode) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  document.documentElement.classList.add('alv5-js');

  function splitHeadings() {
    var heads = document.querySelectorAll('.alv5-h2, .alv5-join__heading, .alv5-cta__content h2');
    heads.forEach(function (h) {
      if (h.dataset.alv5Split) return;
      if (h.children.length) return; /* keep headings with inline markup intact */
      if (!h.closest('[data-alv5-r]')) return; /* only animate ones inside a reveal container */
      h.dataset.alv5Split = '1';
      var words = h.textContent.trim().split(/\s+/);
      h.textContent = '';
      words.forEach(function (w, i) {
        var s = document.createElement('span');
        s.className = 'alv5-w';
        s.style.setProperty('--wi', i);
        s.textContent = w;
        h.appendChild(s);
        if (i < words.length - 1) h.appendChild(document.createTextNode(' '));
      });
    });
  }

  function initReveals() {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('alv5-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -36px 0px' }
    );
    document.querySelectorAll('[data-alv5-r]').forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.9 && rect.bottom > 0) {
        el.classList.add('alv5-in');
        return;
      }
      observer.observe(el);
    });
  }

  function initDrift() {
    document.querySelectorAll('.alv5-reviews__track').forEach(function (track) {
      var paused = true;
      var stopped = false;
      var stop = function () { stopped = true; };
      track.addEventListener('pointerenter', function () { paused = true; });
      track.addEventListener('pointerleave', function () { if (!stopped) paused = false; });
      track.addEventListener('touchstart', stop, { passive: true });
      track.addEventListener('pointerdown', stop);
      track.addEventListener('wheel', stop, { passive: true });
      setTimeout(function () { if (!stopped) paused = false; }, 2500);
      function step() {
        if (stopped) return;
        if (!paused) {
          track.scrollLeft += 0.4;
          if (track.scrollLeft >= track.scrollWidth - track.clientWidth - 2) stopped = true;
        }
        requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  }

  function init() {
    splitHeadings();
    initReveals();
    initDrift();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
